
<div>
  <!--<location-changed v-if="locationChanged"></location-changed>-->
  <price :product="product" :changeZipCode="changeZipCode" :brand_color="brand_color" :organization_id="organization_id"></price>
  <lead-modal v-if="modalOpen" :product="product" @close="modalOpen = false"
    :redirectType="redirectType"></lead-modal>
</div>
